import { getWaitTime } from 'application/connectors/cms/phoneConnector';

export const getPhoneWaitTime = async (phoneNumber: string): Promise<Models.PhoneWaitTime> => {
	try {
		return await getWaitTime(phoneNumber);
	} catch {
		return null;
	}
};
